import './loader2.css'

const Loader2 = () => {
  return <div className="custom-loader2" ></div>;
};

export default Loader2;
